
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class HolidayService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getAllHolidays(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'holiday').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

//   getRole(id: number,isMaintenance: boolean = true): Observable<any> {
//     return this.httpClient.get(this.baseApiUrl + `role/${id}?isMaintenance=${isMaintenance}`).pipe(
//       map((res: Response) => res),
//       catchError((err: any) => observableThrowError(err.message || 'Server error')));
//   }
  createEvent(holiday: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'holiday/create', holiday).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateEvent(holiday: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'holiday/update', holiday).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `holiday/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
 
  savebulkEvent(holiday: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'holiday/savebulkevent', holiday).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
//   authorise(id: number): Observable<any> {
//     return this.httpClient.post(this.baseApiUrl + 'role/authorise', id).pipe(
//       map((res: Response) => res),
//       catchError((err: any) => observableThrowError(err.message || 'Server error')));
//   }

//   getFilteredRoles(filter: string, pageIndex: number, pageSize: number,
//     sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

//     const params = {
//       filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
//     };

//     return this.httpClient.post(this.baseApiUrl + 'role/filter', params).pipe(
//       map((res: any) => res),
//       catchError((err: any) => observableThrowError(err.message || 'Server error')));
//   }

}
